import React from "react";
import PropTypes from "prop-types";
import SourceList from "./SourceList";
import { formatDateTimeShort } from "../../utlis/generalUtils";
import "../../assets/styles/MessageBubble.css";

const MessageBubble = ({ type, text, timestamp, sources = [] }) => {
    const isUser = type === "user";

    return (
        <div className={`message-container ${isUser ? "user-message" : "ai-message"}`}>
            {/* Avatar — only shown for AI messages */}
            {!isUser && (
                <div className="message-avatar ai-avatar">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="10" rx="2" />
                        <circle cx="12" cy="5" r="2" />
                        <line x1="12" y1="7" x2="12" y2="11" />
                    </svg>
                </div>
            )}

            <div className={`message-bubble ${isUser ? "user-bubble" : "ai-bubble"}`}>
                {/* Message text */}
                <p className="message-text">{text}</p>

                {/* Sources — only for AI messages that have sources */}
                {!isUser && sources.length > 0 && <SourceList sources={sources} />}

                {/* Timestamp */}
                <div className={`message-time ${isUser ? "user-time" : "ai-time"}`}>
                    {formatDateTimeShort(timestamp)}
                </div>
            </div>
        </div>
    );
};

// ✅ PropTypes on MessageBubble itself (was incorrectly placed on SourceList before)
MessageBubble.propTypes = {
    type: PropTypes.oneOf(["user", "agent"]).isRequired,
    text: PropTypes.string.isRequired,
    timestamp: PropTypes.number.isRequired,
    sources: PropTypes.array,
};

export default MessageBubble;